import { useReduxSelector } from 'hooks';
import useIsBeta from 'hooks/meta/useIsBeta';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { setGustoHasSignedTos } from 'store/gusto/gusto';
import useGustoCompanyId from '../../company/useGustoCompanyId/useGustoCompanyId';
import useGustoGetTermsOfService from '../useGustoGetTermsOfService/useGustoGetTermsOfService';

export default function useGustoUpdateTermsOfService() {
  const gustoCompanyId = useGustoCompanyId();
  const { me } = useReduxSelector((state) => state.gusto);
  const getTosStatus = useGustoGetTermsOfService();
  const isBeta = useIsBeta();

  const email = me?.email;

  const dispatch = useDispatch();

  return useCallback(async () => {
    if (isBeta) {
      dispatch(setGustoHasSignedTos(true));
    } else if (gustoCompanyId && email) {
      const result = await getTosStatus(gustoCompanyId, email);
      dispatch(setGustoHasSignedTos(result.data.latest_terms_accepted));
    }
  }, [isBeta, gustoCompanyId, email, dispatch, getTosStatus]);
}
